'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.moment.service
 * @description
 * # moment.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('momentService', function(moment) {

    var momentService = {};

    momentService.getUtcDayId = getUtcDayId;
    momentService.getMomentFromDayId = getMomentFromDayId;
    momentService.getCurrentMoment = getCurrentMoment;
    momentService.getDatesArray = getDatesArray;
    momentService.getMomentFromView = getMomentFromView;
    momentService.getMonthStart = getMonthStart;
    momentService.getMonthEnd = getMonthEnd;
    momentService.getWeekendDates = getWeekendDates;

    return momentService;

    function getUtcDayId(moment) {
      var dayOfYear = moment.dayOfYear();
      var year = moment.year();
      return Number(dayOfYear + '' + year);
    }

    function getMomentFromDayId(dayId) {
      var dayIdStr = String(dayId).padStart(7, '0');
      return moment(dayIdStr, 'DDDYYYY');
    }

    function getCurrentMoment(view) {
      return getMomentFromView(view)
        .set({
          'hour': 8,
          'minute': 30,
          'second': 0
        });
    }

    function getDatesArray(events, customerId, homeId, orderId) {
      var datesArray;
      if (!!homeId) {
        datesArray = events.filter(function(item) {
          return item.customerId === customerId &&
            item.homeId === homeId &&
            item.orderId === orderId;
        });
      } else {
        datesArray = events.filter(function(item) {
          return item.customerId === customerId;
        });
      }

      var daysAddedArray = [];
      datesArray.forEach(function(event) {
        var dateToAdd = moment(event.start).format('Do');
        daysAddedArray.push(dateToAdd);
      });

      return daysAddedArray.sort().join(', ');
    }

    function getMomentFromView(view) {
      var viewMoment = view.intervalStart;
      var newMoment = moment(viewMoment.valueOf());
      return viewMoment.hasTime() ? viewMoment : newMoment;
    }

    function getMonthStart(monthYearFor) {
      var monthMoment = moment(monthYearFor, 'MMMM YYYY');
      var first = moment(monthMoment).startOf('month');
      return first.day() % 6 === 0 ? first.add(1, 'day').day(1) : first;
    }

    function getMonthEnd(monthYearFor) {
      var monthMoment = moment(monthYearFor, 'MMMM YYYY');
      var end = moment(monthMoment).endOf('month');
      if (end.day() === 0) {
        return end.subtract(2, 'day');
      }
      if (end.day() % 6 === 0) {
        return end.subtract(1, 'day');
      } else {
        return end;
      }
    }

    function getWeekendDates(minDate, maxDate) {
      var minDateMoment = moment(minDate);
      var maxDateMoment = moment(maxDate);
      var weekendDates = [];
      var minDayId = minDateMoment.dayOfYear();
      var maxDayId = maxDateMoment.dayOfYear();
      while (minDayId <= maxDayId) {
        if (minDateMoment.day() === 0 || minDateMoment.day() === 6) {
          weekendDates.push(angular.copy(minDateMoment.toDate()));
        }

        minDayId++;
        minDateMoment = minDateMoment.add(1, 'days');
      }
      return weekendDates;
    }
  });
